export default __webpack_public_path__ + "static/media/mark-sheet-template-2.9138fbf9.png";